"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transports = void 0;
const polling_js_1 = require("./polling.js");
const websocket_js_1 = require("./websocket.js");
exports.transports = {
    websocket: websocket_js_1.WS,
    polling: polling_js_1.Polling
};



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/build/cjs/transports/index.js
// module id = 221
// module chunks = 0